<template>
  <LayoutContent :colors="$site.colors">
    <RootContainer>
      <b-container class="mt-12">
        <b-container class="mt-12">
          <div class="max-w-lg mx-auto">
            <b-card v-if="success" :title="$t('pages.payment.success')" class="mb-3" variant="success">
              <p class="text-center text-sm text-secondary">
                {{ $t('pages.payment.successMessage') }}
              </p>
            </b-card>

            <b-card v-else-if="errors && errors.length" :title="$t('pages.payment.error')" class="mb-3 mt-3" variant="danger">
              <p class="text-center text-sm text-secondary">
                {{ $t('pages.payment.errorMessage') }}
              </p>
              <ul class="text-center text-sm text-secondary list-disc ml-2 pl-2">
                <li v-for="error in errors" :key="error">
                  {{ error }}
                </li>
              </ul>
            </b-card>
          </div>
        </b-container>
      </b-container>
    </RootContainer>
  </LayoutContent>
</template>

<script setup lang="ts">
import { Buffer } from 'buffer';
import PaymentIntegrations from '@/components/payments/integrations'

const route = useRoute()
const router = useRouter()
const { $api } = useNuxtApp()

const otherWindow = ref(false)
const success = ref(false)
const errors = ref(null)


onMounted(async () => {
  const query = route.query

  if (query.integration) {
    const integrationGuid = query.integration
    const selectedPaymentIntegration = PaymentIntegrations[integrationGuid]

    const callbackResponse = await selectedPaymentIntegration.externalPaymentCallback(integrationGuid)

    if (window.opener) {
      window.postRobot?.send(window.opener, 'payment.external.callback', callbackResponse).then(function (event: any) {
        if (event.data && event.data.success) {
          otherWindow.value = true
          window.close()
        } else {
          redirectToFallback(selectedPaymentIntegration, callbackResponse)
        }
      }).catch(function () {
        redirectToFallback(selectedPaymentIntegration, callbackResponse)
      })
    } else {
      redirectToFallback(selectedPaymentIntegration, callbackResponse)
    }
  }
})

const redirectToFallback = async (integration, callbackResponse) => {
  const query = route.query
  const stateJson = Buffer.from(query.state, 'base64').toString()
  const stateObject = JSON.parse(stateJson)

  const state = await $api.location.getState({ key: stateObject.key, auth: stateObject.auth })

  if (!state) {
    router.push({ path: '/book-now' })
    return
  }

  const fallbackObject = state.data

  const paymentCallback = Buffer.from(JSON.stringify({ integration: integration.guid, response: callbackResponse })).toString('base64')
  fallbackObject.query = fallbackObject.query || {}
  fallbackObject.query.paymentCallback = paymentCallback

  router.push(fallbackObject)
}

</script>
